/**
 * Smart Wishlist Button Rewiring Script
 * Intercepts Smart Wishlist app buttons and makes them use your custom backend
 *
 * Add this script AFTER the Smart Wishlist app script loads
 */

(function() {
  'use strict';

  // Configuration
  const API_ENDPOINT = 'https://klaviyo-backend-smoky.vercel.app/api/wishlist-toggle';
  const COUNTRY_CODE = 'PL'; // Change to your country: DK, SE, NO, DE, NL, FR, FI, PL
  const ENABLE_KLAVIYO_SYNC = true;

  // Get customer info
  function getCustomerInfo() {
    if (window.Shopify && window.Shopify.customer) {
      return {
        customerId: window.Shopify.customer.id,
        customerEmail: window.Shopify.customer.email
      };
    }
    return null;
  }

  // Check if product is in wishlist (from localStorage for quick UI updates)
  function isInWishlist(productId) {
    try {
      const wishlist = JSON.parse(localStorage.getItem('custom_wishlist') || '[]');
      return wishlist.includes(productId.toString());
    } catch (e) {
      return false;
    }
  }

  // Update localStorage wishlist
  function updateLocalWishlist(productId, add) {
    try {
      let wishlist = JSON.parse(localStorage.getItem('custom_wishlist') || '[]');
      productId = productId.toString();

      if (add && !wishlist.includes(productId)) {
        wishlist.push(productId);
      } else if (!add) {
        wishlist = wishlist.filter(id => id !== productId);
      }

      localStorage.setItem('custom_wishlist', JSON.stringify(wishlist));
    } catch (e) {
      console.error('Failed to update localStorage:', e);
    }
  }

  // Update button visual state
function updateButtonState(container, isBookmarked) {
    const button = container.querySelector('#bookmarkit');
    const icon = container.querySelector('#wishlist_icon');

    if (isBookmarked) {
      button?.setAttribute('status', 'bookmarked');
      button?.classList.remove('unbookmarked');
      button?.classList.add('bookmarked');
      if (icon) {
        icon.className = 'fa fa-heart';
      }
    } else {
      button?.setAttribute('status', 'unbookmarked');
      button?.classList.remove('bookmarked');
      button?.classList.add('unbookmarked');
      if (icon) {
        icon.className = 'fa fa-heart-o';
      }
    }
  }

  // Toggle wishlist via your backend
  async function toggleWishlist(productId, variantId, isCurrentlyBookmarked) {
    const customer = getCustomerInfo();

    if (!customer) {
      alert('Please log in to use wishlist');
      window.location.href = '/account/login';
      return false;
    }

    try {
      const response = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          productId: productId,
          variantId: variantId,
          customerId: customer.customerId,
          customerEmail: customer.customerEmail,
          action: isCurrentlyBookmarked ? 'remove' : 'add',
          country: COUNTRY_CODE,
          syncToKlaviyo: ENABLE_KLAVIYO_SYNC
        })
      });

      const result = await response.json();

      if (result.success) {
        // Update localStorage
        updateLocalWishlist(productId, !isCurrentlyBookmarked);
        return true;
      } else {
        throw new Error(result.error || 'Failed to update wishlist');
      }
    } catch (error) {
      console.error('Wishlist error:', error);
      alert(error.message || 'Failed to update wishlist');
      return false;
    }
  }

  // Rewire a Smart Wishlist button
  function rewireButton(container) {
    const button = container.querySelector('#bookmarkit');
    if (!button || button.dataset.rewired) return;

    const productId = container.getAttribute('data-product');
    const variantId = container.getAttribute('data-variant');

    if (!productId) {
      console.warn('No product ID found on Smart Wishlist button');
      return;
    }

    // Mark as rewired to avoid duplicate handlers
    button.dataset.rewired = 'true';

    // Set initial state from localStorage
    const isBookmarked = isInWishlist(productId);
    updateButtonState(container, isBookmarked);

    // Remove all existing event listeners by cloning the element
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);

    // Add our custom click handler
    newButton.addEventListener('click', async function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const currentStatus = newButton.getAttribute('status');
      const isCurrentlyBookmarked = currentStatus === 'bookmarked';

      // Optimistically update UI
      updateButtonState(container, !isCurrentlyBookmarked);

      // Call backend
      const success = await toggleWishlist(productId, variantId, isCurrentlyBookmarked);

      // Revert UI if failed
      if (!success) {
        updateButtonState(container, isCurrentlyBookmarked);
      }
    });

    console.log('✓ Rewired Smart Wishlist button for product:', productId);
  }

  // Find and rewire all Smart Wishlist buttons
  function rewireAllButtons() {
    const containers = document.querySelectorAll('#smartwishlist');
    containers.forEach(container => rewireButton(container));
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewireAllButtons);
  } else {
    rewireAllButtons();
  }

  // Watch for dynamically added buttons (e.g., AJAX quick view, collection pages)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          if (node.id === 'smartwishlist') {
            rewireButton(node);
          } else {
            const buttons = node.querySelectorAll && node.querySelectorAll('#smartwishlist');
            if (buttons) buttons.forEach(rewireButton);
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Re-initialize on section reload (Shopify theme editor)
  document.addEventListener('shopify:section:load', rewireAllButtons);

  console.log('Smart Wishlist Rewire Script loaded');
})();
